/* tslint:disable */
/* eslint-disable */
/**
 * Indexer Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface SuvisiaciProces
 */
export interface SuvisiaciProces {
    /**
     * 
     * @type {string}
     * @memberof SuvisiaciProces
     */
    'iri'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuvisiaciProces
     */
    'menovka'?: string;
    /**
     * 
     * @type {string}
     * @memberof SuvisiaciProces
     */
    'popis'?: string;
}

/**
 * NovelizovanyPredpisListApi - axios parameter creator
 * @export
 */
export const NovelizovanyPredpisListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [typ] typ of predpisZbierky
         * @param {string} [dopyt] search text for suvisiaci proces list
         * @param {string} [sort] sort by specified attribute
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNovelizovanyPredpisList: async (typ?: string, dopyt?: string, sort?: string, rows?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/predpisZbierky/navrhy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }

            if (dopyt !== undefined) {
                localVarQueryParameter['dopyt'] = dopyt;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (rows !== undefined) {
                localVarQueryParameter['rows'] = rows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NovelizovanyPredpisListApi - functional programming interface
 * @export
 */
export const NovelizovanyPredpisListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NovelizovanyPredpisListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [typ] typ of predpisZbierky
         * @param {string} [dopyt] search text for suvisiaci proces list
         * @param {string} [sort] sort by specified attribute
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNovelizovanyPredpisList(typ?: string, dopyt?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuvisiaciProces>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNovelizovanyPredpisList(typ, dopyt, sort, rows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NovelizovanyPredpisListApi.getNovelizovanyPredpisList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NovelizovanyPredpisListApi - factory interface
 * @export
 */
export const NovelizovanyPredpisListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NovelizovanyPredpisListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [typ] typ of predpisZbierky
         * @param {string} [dopyt] search text for suvisiaci proces list
         * @param {string} [sort] sort by specified attribute
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNovelizovanyPredpisList(typ?: string, dopyt?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuvisiaciProces>> {
            return localVarFp.getNovelizovanyPredpisList(typ, dopyt, sort, rows, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NovelizovanyPredpisListApi - object-oriented interface
 * @export
 * @class NovelizovanyPredpisListApi
 * @extends {BaseAPI}
 */
export class NovelizovanyPredpisListApi extends BaseAPI {
    /**
     * 
     * @param {string} [typ] typ of predpisZbierky
     * @param {string} [dopyt] search text for suvisiaci proces list
     * @param {string} [sort] sort by specified attribute
     * @param {number} [rows] Maximum number of results in the output (default 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NovelizovanyPredpisListApi
     */
    public getNovelizovanyPredpisList(typ?: string, dopyt?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig) {
        return NovelizovanyPredpisListApiFp(this.configuration).getNovelizovanyPredpisList(typ, dopyt, sort, rows, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SuvisiaciProcesListApi - axios parameter creator
 * @export
 */
export const SuvisiaciProcesListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [dopyt] search text for suvisiaci proces list
         * @param {string} [sort] sort by specified attribute
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuvisiaciProcesList: async (dopyt?: string, sort?: string, rows?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/legislativnyMaterial/navrhy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dopyt !== undefined) {
                localVarQueryParameter['dopyt'] = dopyt;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (rows !== undefined) {
                localVarQueryParameter['rows'] = rows;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuvisiaciProcesListApi - functional programming interface
 * @export
 */
export const SuvisiaciProcesListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuvisiaciProcesListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [dopyt] search text for suvisiaci proces list
         * @param {string} [sort] sort by specified attribute
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuvisiaciProcesList(dopyt?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuvisiaciProces>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuvisiaciProcesList(dopyt, sort, rows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuvisiaciProcesListApi.getSuvisiaciProcesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuvisiaciProcesListApi - factory interface
 * @export
 */
export const SuvisiaciProcesListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuvisiaciProcesListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [dopyt] search text for suvisiaci proces list
         * @param {string} [sort] sort by specified attribute
         * @param {number} [rows] Maximum number of results in the output (default 100)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuvisiaciProcesList(dopyt?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuvisiaciProces>> {
            return localVarFp.getSuvisiaciProcesList(dopyt, sort, rows, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuvisiaciProcesListApi - object-oriented interface
 * @export
 * @class SuvisiaciProcesListApi
 * @extends {BaseAPI}
 */
export class SuvisiaciProcesListApi extends BaseAPI {
    /**
     * 
     * @param {string} [dopyt] search text for suvisiaci proces list
     * @param {string} [sort] sort by specified attribute
     * @param {number} [rows] Maximum number of results in the output (default 100)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuvisiaciProcesListApi
     */
    public getSuvisiaciProcesList(dopyt?: string, sort?: string, rows?: number, options?: RawAxiosRequestConfig) {
        return SuvisiaciProcesListApiFp(this.configuration).getSuvisiaciProcesList(dopyt, sort, rows, options).then((request) => request(this.axios, this.basePath));
    }
}



